import type { ContentItem } from "@/types/content";

export const tvShows: ContentItem[] = [
  {
    id: "tv-01",
    category: "tv-update",
    title: "长风渡月",
    summary:
      "古装权谋剧，讲述女主在乱世中步步为营、守护家国的成长故事，人物群像饱满。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20historical%20drama%20poster%20with%20elegant%20red%20robe%20and%20ancient%20architecture%2C%20refined%20oriental%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv01-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-11",
    year: "2026",
    genre: "古装 / 权谋",
    region: "中国",
    initial: "C",
    latestEpisode: "更新至第 28 集",
    heat: 94,
    content:
      "<p>《长风渡月》是一部古装权谋剧，以女主在乱世中的成长为主线，串联起家族、朝堂与家国的多重线索。</p><h3>看点</h3><p>剧集制作考究，服化道与场景颇具质感。人物群像塑造饱满，多条支线都各有看点。</p><p>最新剧情已更新至第 28 集，剧情进入高潮阶段。</p>",
  },
  {
    id: "tv-02",
    category: "tv-update",
    title: "都市夜归人",
    summary:
      "都市情感剧，聚焦都市青年的工作与生活，用细腻笔触描绘当代年轻人的真实处境。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20with%20city%20night%20skyline%20and%20warm%20window%20lights%2C%20cinematic%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv02-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-10",
    year: "2026",
    genre: "都市 / 情感",
    region: "中国",
    initial: "D",
    latestEpisode: "更新至第 20 集",
    heat: 88,
    content:
      "<p>《都市夜归人》聚焦都市青年的工作与生活，用细腻的笔触描绘当代年轻人的真实处境。</p><h3>看点</h3><p>剧情贴近现实，台词生活化，容易引发共鸣。多条人物线交织，展现了都市生活的不同侧面。</p><p>目前剧集已更新至第 20 集。</p>",
  },
  {
    id: "tv-03",
    category: "tv-update",
    title: "迷雾档案",
    summary:
      "悬疑刑侦剧，以一系列离奇案件为线索，抽丝剥茧还原真相，节奏紧凑反转不断。",
    cover:
      "https://readdy.ai/api/search-image?query=suspense%20crime%20drama%20poster%20with%20foggy%20city%20and%20a%20single%20streetlight%2C%20dark%20moody%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv03-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-09",
    year: "2026",
    genre: "悬疑 / 刑侦",
    region: "中国",
    initial: "M",
    latestEpisode: "更新至第 16 集",
    heat: 91,
    content:
      "<p>《迷雾档案》是一部悬疑刑侦剧，以一系列离奇案件为线索，通过抽丝剥茧的推理还原真相。</p><h3>看点</h3><p>剧集节奏紧凑，几乎每集都有新的悬念抛出，反转设置令人称快。案件背后的社会议题也引发讨论。</p><p>最新已更新至第 16 集。</p>",
  },
  {
    id: "tv-04",
    category: "tv-update",
    title: "小城四季",
    summary:
      "生活流家庭剧，讲述小城里几户人家的悲欢日常，平淡中见真情。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20slice%20of%20life%20drama%20poster%20with%20a%20small%20town%20street%20in%20autumn%20and%20warm%20light%2C%20gentle%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv04-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-08",
    year: "2026",
    genre: "家庭 / 生活",
    region: "中国",
    initial: "X",
    latestEpisode: "更新至第 24 集",
    heat: 80,
    content:
      "<p>《小城四季》是一部生活流家庭剧，讲述小城里几户人家的悲欢日常，平淡之中见真情。</p><h3>看点</h3><p>剧集节奏舒缓，人物真实接地气，把生活里的细碎温暖拍得格外动人，适合慢慢品味。</p><p>目前已更新至第 24 集。</p>",
  },
  {
    id: "tv-05",
    category: "tv-update",
    title: "风起南屿",
    summary:
      "青春成长剧，讲述一群年轻人在海岛小城追逐梦想的故事，画面清新、氛围治愈。",
    cover:
      "https://readdy.ai/api/search-image?query=youth%20drama%20poster%20with%20sunny%20seaside%20town%20and%20palm%20trees%2C%20fresh%20warm%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv05-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-06",
    year: "2026",
    genre: "青春 / 成长",
    region: "中国",
    initial: "F",
    latestEpisode: "更新至第 12 集",
    heat: 74,
    content:
      "<p>《风起南屿》讲述一群年轻人在海岛小城追逐梦想的故事。剧集画面清新，氛围治愈，充满青春气息。</p><h3>看点</h3><p>取景优美，配乐动听，关于友情与梦想的表达真挚自然，很适合在休闲时光观看。</p><p>最新更新至第 12 集。</p>",
  },
  {
    id: "tv-06",
    category: "tv-update",
    title: "旧案新证",
    summary:
      "法律题材剧集，围绕一桩多年旧案的重审展开，探讨真相、正义与人情之间的博弈。",
    cover:
      "https://readdy.ai/api/search-image?query=legal%20drama%20poster%20with%20a%20courtroom%20and%20stacked%20case%20files%2C%20serious%20muted%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv06-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-04",
    year: "2026",
    genre: "法律 / 剧情",
    region: "中国",
    initial: "J",
    latestEpisode: "更新至第 18 集",
    heat: 77,
    content:
      "<p>《旧案新证》围绕一桩多年旧案的重审展开，探讨真相、正义与人情之间的复杂博弈。</p><h3>看点</h3><p>剧本扎实，逻辑缜密，法庭戏张力十足。人物在法与情之间的抉择颇具思考价值。</p><p>目前已更新至第 18 集。</p>",
  },
  {
    id: "tv-07",
    category: "tv-update",
    title: "荒原信使",
    summary:
      "科幻悬疑剧，背景设定在资源枯竭的未来，讲述信使穿越荒原传递希望的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20sci-fi%20series%20poster%20with%20a%20lone%20traveler%20on%20a%20barren%20landscape%2C%20red%20dusty%20sky%2C%20vertical%20layout&width=600&height=880&seq=tv07-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-10-02",
    year: "2026",
    genre: "科幻 / 悬疑",
    region: "中国",
    initial: "H",
    latestEpisode: "更新至第 10 集",
    heat: 82,
    content:
      "<p>《荒原信使》背景设定在资源枯竭的未来世界，讲述信使穿越荒原传递希望的故事。</p><h3>看点</h3><p>世界观设定独特，美术风格鲜明，荒原景观的呈现极具氛围感。剧集在冒险之外也有对文明的思考。</p><p>目前更新至第 10 集。</p>",
  },
  {
    id: "tv-08",
    category: "tv-update",
    title: "厨房里的春天",
    summary:
      "美食治愈剧，以一家小餐馆为舞台，用一道道家常菜串联起食客们的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20food%20drama%20poster%20with%20a%20warm%20kitchen%20and%20steaming%20dishes%2C%20appetizing%20warm%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv08-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-09-30",
    year: "2026",
    genre: "美食 / 治愈",
    region: "中国",
    initial: "C",
    latestEpisode: "更新至第 14 集",
    heat: 73,
    content:
      "<p>《厨房里的春天》以一家小餐馆为舞台，用一道道家常菜串联起食客们的故事，温暖而治愈。</p><h3>看点</h3><p>美食镜头诱人，故事单元短小精悍，每一集都能带来一点小确幸，非常适合下饭观看。</p><p>目前已更新至第 14 集。</p>",
  },
  {
    id: "tv-09",
    category: "tv-update",
    title: "北纬三十度",
    summary:
      "探险纪实风格剧集，跟随一支科考队伍深入秘境，揭开自然与人文交织的谜题。",
    cover:
      "https://readdy.ai/api/search-image?query=adventure%20documentary%20series%20poster%20with%20misty%20mountains%20and%20a%20distant%20expedition%20team%2C%20muted%20natural%20tone%2C%20vertical%20layout&width=600&height=880&seq=tv09-poster&orientation=portrait",
    author: "红桃网追剧组",
    date: "2026-09-28",
    year: "2026",
    genre: "探险 / 纪实",
    region: "中国",
    initial: "B",
    latestEpisode: "更新至第 8 集",
    heat: 69,
    content:
      "<p>《北纬三十度》以一支科考队伍的深入探索为主线，揭开自然与人文交织的层层谜题。</p><h3>看点</h3><p>剧集取景壮美，叙事兼具知识性与故事性，跟随镜头仿佛也完成了一次深入秘境之旅。</p><p>目前更新至第 8 集。</p>",
  },
];